import { render, staticRenderFns } from "./merchantDetail.vue?vue&type=template&id=73e84dbd&scoped=true&"
import script from "./merchantDetail.vue?vue&type=script&lang=js&"
export * from "./merchantDetail.vue?vue&type=script&lang=js&"
import style0 from "./merchantDetail.vue?vue&type=style&index=0&id=73e84dbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e84dbd",
  null
  
)

export default component.exports